import useDarkLayout from "../../components/loyauts/use-dark-layout";
import NextLink from "../../components/next-link";
import Welcome from "../../components/welcome";
import useUser from "../../modules/user/hooks/use-user";
import { getMapRoute } from "../routes";

type Props = {}

const WelcomePage: React.FC<Props> = () => {

    useDarkLayout();
    const { libraryCode } = useUser();

    return <>
        <h1>Noc bibliotek 2021</h1>
        <div className="page-box">
            <div className="page-box-content">
                {libraryCode && <Welcome libraryCode={libraryCode} />}
            </div>
        </div>
        <div className="post-page-box-links">
            <NextLink to={getMapRoute()}>Dalej</NextLink>
        </div>
    </>
}

export default WelcomePage;
